import styled from "@emotion/styled";
import { range } from "ramda";
import { Grid, Box } from "@mui/material";

import Placeholder from "components/Placeholder";

const SkeletonContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  padding: 10,
  columnGap: 60,
  flexWrap: "nowrap",
  overflowX: "scroll",
  overflowY: "hidden",
  flexDirection: "row",
  alignItems: "center",
  wrap: "nowrap",
  width: "100%",
  "&::-webkit-scrollbar": { display: "none" },
  scrollbarWidth: "none",
  [theme.breakpoints.up("mobile")]: {
    columnGap: 100,
  },
  [theme.breakpoints.up("tablet")]: {
    width: 400,
    columnGap: 0,
    display: "grid",
    justifyContent: "space-around",
    alignContent: "space-between",
    alignItems: "start",
    gridTemplateColumns: "1fr 1fr 1fr",
    rowGap: 180,
    height: 280,
    overflowX: "hidden",
    overflowY: "scroll",
  },
}));

const FacesSkeleton = () => {
  return (
    <Grid container justifyContent="center" data-testid="faces-component-placeholder">
      <SkeletonContainer>
        {range(0, 6).map((index) => (
          <Box key={`placeholder-face-${index}`} data-testid={`placeholder-face-${index}`}>
            <Placeholder variant="circular" ratio="1/1" height={140} width={100} />
          </Box>
        ))}
      </SkeletonContainer>
    </Grid>
  );
};

export default FacesSkeleton;
